import { FirestoreQueryBuilder } from '../../../../lib/gcp/builder/firestore-query.builder';
import { IRepository } from '../../../../utility/repository/repository';
import { Integration } from '../entity';
import { IntegrationId } from '../value';
import { Observable } from 'rxjs';

export abstract class IIntegrationRepository extends IRepository<IntegrationId, Integration> {
  abstract selectAll(builder: FirestoreQueryBuilder<Integration>): Observable<Integration>;
}
